import React from 'react';
import { KeyValuePair } from 'tailwindcss/types/config';

export function ProhibitedItems({items}: {items: KeyValuePair<string, string>}) {
  return (
    <div className='tw-mt-6 tw-mb-12'>
      <h1>{items.Title}</h1>
      <div className='tw-font-bold'>Passengers are not permitted to carry the below mentioned items/articles/dangerous goods in their cabin or checked luggage:</div>
      <div className='tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-4 tw-mt-6'>
        <ListItem imageName="corrosives.png" imageAlt="Corrosives">Corrosives such as mercury, acids, alkalis, and wet cell batteries.</ListItem>
        <ListItem imageName="flames.png" imageAlt="Flammable liquids">Flammable liquids and solids such as lighter or heater fuels, paint, and all matches.</ListItem>
        <ListItem imageName="infectious.png" imageAlt="Infectious substances">Infectious substances such as bacteria and viruses.</ListItem>

        <ListItem imageName="oxidizes.png" imageAlt="Oxidizing materials">Oxidizing materials and organic peroxides such as bleaches and fiberglass repair kits.</ListItem>
        <ListItem imageName="gases.png" imageAlt="Compressed gases">Compressed gases (deeply refrigerated, flammable, non-flammable, and poisonous) such as butane, oxygen, propane, and diving cylinders.</ListItem>
        <ListItem imageName="weapons.png" imageAlt="Electroshock weapons">Electroshock weapons (e.g., taser, pepper spray, mace, animal repellents).</ListItem>

        <ListItem imageName="explosives.png" imageAlt="Explosives">Explosives and incendiary devices (including replicas), e.g., fireworks and ammunition.</ListItem>
        <ListItem imageName="sports.png" imageAlt="Sporting ammunition">Sporting ammunition up to 5 kg may be carried properly boxed in checked baggage. Contact SalamAir office for prior approval.</ListItem>
        <ListItem imageName="poisons.png" imageAlt="Poisons">Poisons such as insecticides, weedkillers, arsenic, and cyanides.</ListItem>

        <ListItem imageName="radios.png" imageAlt="Radioactive material">Radioactive material.</ListItem>
        <ListItem imageName="vehicles.png" imageAlt="Small vehicles">Small vehicles powered by lithium batteries.</ListItem>
        <ListItem imageName="explosives.png" imageAlt="Explosives">Lithium batteries & equipment powered by lithium batteries:
          <ul className='tw-list-outside tw-list-disc tw-pl-4'>
            <li>Multiple restrictions are applicable.</li>
            <li>Please contact SalamAir staff for more information. Examples include power banks, drones, e-cigarettes, smart luggage, and loose batteries.</li>
          </ul>
      </ListItem>


      </div>

      <div className='sa-text-blue tw-text-xl'>Additional Notes</div>
      <div className='tw-flex tw-flex-col tw-gap-1 tw-mt-2'>
        <NoteItem imageName='add1.png' imageAlt='Firearms and/or ammunition'>Firearms and/or ammunition must be declared at check-in.</NoteItem>
        <NoteItem imageName='add2.png' imageAlt='Mobility aids'>Mobility aids (i.e. Wheelchairs) powered by any type of battery must be declared at least two hours prior to the check-in counter closing.</NoteItem>
        <NoteItem imageName='add3.png' imageAlt='Medicines and toilet articles'>Medicines and toilet articles in small quantities may be carried.</NoteItem>
      </div>
    </div>
  )
}

export function ProhibitedItemsAR({items}: {items: KeyValuePair<string, string>}) {
  return (
    <div className='tw-mt-6 tw-mb-12'>
      <h1>{items.Title}</h1>
      <div className='tw-font-bold'>لمواد الخطرة غير المسموح بها الحقائب</div>
      <div className='tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-4 tw-mt-6'>
        <ListItem imageName="corrosives.png" imageAlt="Corrosives">المواد المسببة للتآكل مثل الزئبق والأحماض و القلويات وبطاريات الخلايا الرطبة.</ListItem>
        <ListItem imageName="flames.png" imageAlt="Flammable liquids">السوائل والمواد الصلبة القابلة للاشتعال مثل وقود الولاعات أو السخانات أو الدهان وجميع أنواع الكبريت.</ListItem>
        <ListItem imageName="infectious.png" imageAlt="Infectious substances">المواد المعدية مثل البكتيريا والفيروسات.</ListItem>

        <ListItem imageName="oxidizes.png" imageAlt="Oxidizing materials">المواد المؤكسدة والبيروكسيدات العضوية مثل مواد التبييض ومجموعات إصلاح الألياف الزجاجية.</ListItem>
        <ListItem imageName="gases.png" imageAlt="Compressed gases">الغازات المضغوطة (شديدة التبريد، قابلة للاشتعال، غير قابلة للاشتعال، والسامة) مثل البيوتان والأكسجين والبروبان و وأسطوانات الغوص.</ListItem>
        <ListItem imageName="weapons.png" imageAlt="Electroshock weapons">الأسلحة الكهربائية (مثل الصاعق الكهربائي، رذاذ الفلفل، الغاز المسيل للدموع، ومواد طرد الحيوانات).</ListItem>

        <ListItem imageName="explosives.png" imageAlt="Explosives">المتفجرات والأجهزة الحارقة (بما في ذلك النسخ المقلدة)، مثل الألعاب النارية والذخيرة.</ListItem>
        <ListItem imageName="sports.png" imageAlt="Sporting ammunition">يمكن حمل ذخيرة رياضية بوزن يصل إلى 5 كجم مُعبأة بشكل صحيح في الأمتعة المسجلة. يرجى التواصل مع مكتب طيران السلام للحصول على الموافقة المسبقة.</ListItem>
        <ListItem imageName="poisons.png" imageAlt="Poisons">السموم مثل مبيدات الحشرات و مبيدات الأعشاب و الزرنيخ و والسيانيد.</ListItem>

        <ListItem imageName="radios.png" imageAlt="Radioactive material">المواد المـُــشعّة</ListItem>
        <ListItem imageName="vehicles.png" imageAlt="Small vehicles">المركبات الصغيرة التي تعمل ببطاريات الليثيوم.</ListItem>
        <ListItem imageName="explosives.png" imageAlt="Explosives">تنطبق عدة قيود:
          <ul className='tw-list-outside tw-list-disc tw-pl-4'>
            <li>يرجى التواصل مع موظفي طيران السلام لمزيد من المعلومات.</li>
            <li>أمثلة تشمل: بطاريات الشحن (Power Banks)، الطائرات بدون طيار (Drones)، السجائر الإلكترونية، الحقائب الذكية، والبطاريات المنفصلة.</li>
          </ul>
        </ListItem>
      </div>

      <div className='sa-text-blue tw-text-xl'>ملاحظات إضافية:</div>
      <div className='tw-flex tw-flex-col tw-gap-1 tw-mt-2'>
        <NoteItem imageName='add1.png' imageAlt='Firearms and/or ammunition'>يجب التصريح عن الأسلحة النارية و/أو الذخيرة عند التسجيل للرحلة. </NoteItem>
        <NoteItem imageName='add2.png' imageAlt='Mobility aids'>يجب التصريح عن وسائل التنقل (مثل الكراسي المتحركة) التي تعمل بأي نوع من البطاريات قبل ساعتين على الأقل من إغلاق منضدات التسجيل للرحلة.</NoteItem>
        <NoteItem imageName='add3.png' imageAlt='Medicines and toilet articles'>يمكن حمل الأدوية ومستحضرات التجميل بكميات صغيرة.</NoteItem>
      </div>
    </div>
  )
}

function ListItem({imageName, imageAlt, children }: {imageName: string, imageAlt: string, children: React.ReactNode}) {

  return (
    <div className='tw-flex tw-flex-row tw-gap-2'>
      <div className='sa-bg-green tw-size-12'>
        <img src={`/images/prohibited/${imageName}`} alt={imageAlt} className='tw-size-11' />
      </div>
      <div>{children}</div>
    </div>
  )
}

function NoteItem({imageName, imageAlt, children}: {imageName: string, imageAlt: string, children: React.ReactNode}) {
  return (
    <div className='tw-flex tw-flex-row tw-gap-1'>
      <div className='tw-size-7'>
        <img src={`/images/prohibited/${imageName}`} alt={imageAlt} className='tw-size-6' />
      </div>
      <div className='tw-max-w-lg'>{children}</div>
    </div>
  )
}